var $ = jQuery.noConflict();

$(document).ready(function () {
    //Flex concertina
    $('.concertina-section').each(function () {
        $(this).find('.concertina-section-title').click(function () {
            if ($(this).parent().hasClass('open')) {
                $(this).parent().find('.concertina-section-content').stop().slideUp().parent().removeClass('open');   
            }
            else {
                $('.wp-block-acf-concertina .concertina-section.open').removeClass('open').find('.concertina-section-content').slideUp();
                $(this).parent().find('.concertina-section-content').stop().slideDown().parent().addClass('open');
            }
        })
    });
    
    //Flex gallery
    var gallerySlider = $('section.flex-content-block.gallery .slider-container');

    gallerySlider.each(function () {
        var gallerySliderStatus = $(this).siblings('.block-text-container').find('.slider-info');
        gallerySlider.on('init reInit afterChange', function (event, slick, currentSlide) {
            //currentSlide is undefined on init so set it to 0 in this case
            var slideNumber = (currentSlide ? currentSlide : 0) + 1; // currentSlide is 0 based

            if (slick.slideCount <= 1) {
                gallerySliderStatus.hide();
            }

            slideCount = slick.slideCount;
            gallerySliderStatus.text(slideNumber + '/' + slideCount);
        });
        $(this).slick({
            slide: '.slide',
            asNavFor: $(this).siblings('.block-text-container').find('.caption-container'),
            slidesToShow: 1,
            dots: false,
            rows: 0,
            prevArrow: $(this).siblings('.block-text-container').find('.prev-arrow'),
            nextArrow: $(this).siblings('.block-text-container').find('.next-arrow'),
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        arrows: true,
                    }
                }
            ]
        });
        $(this).siblings('.block-text-container').find('.caption-container').slick({
            slide: '.slide',
            slidesToShow: 1,
            slidesToScroll: 1,
            rows: 0,
            arrows: false,
            asNavFor: $(this),
            responsive: [
                {
                    breakpoint: 1000,
                    settings: {
                        adaptiveHeight: true
                    }
                }
            ]
        });
    });

    //Flex testimonials
    var testimonialsSlider = $('section.flex-content-block.testimonials .quotes-slider');

    testimonialsSlider.each(function () {
        var testimonialsSliderStatus = $(this).siblings('.block-text-container').find('.slider-info');
        testimonialsSlider.on('init reInit afterChange', function (event, slick, currentSlide) {
            //currentSlide is undefined on init so set it to 0 in this case
            var slideNumber = (currentSlide ? currentSlide : 0) + 1; // currentSlide is 0 based

            if (slick.slideCount <= 1) {
                testimonialsSliderStatus.hide();
            }

            slideCount = slick.slideCount;
            testimonialsSliderStatus.text(slideNumber + '/' + slideCount);
        });
        $(this).slick({
            slide: '.slide',
            slidesToShow: 3,
            autoplay: true,
            autoplaySpeed: 3500,
            dots: true,
            appendDots: $(this).siblings('.slider-nav').find('.slider-dots'),
            arrows: false,
            rows: 0,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });
    });

    //Flex Info Block
    if ($('section.flex-content-block.information-block').hasClass('filtered')) {
        $('html, body').animate({scrollTop: $('section.flex-content-block.information-block').offset().top}, 800);
    }

    //Anchor links scroll
    $(document).on('click', '.wysiwyg-content a[href^="#"]', function (event) {
        event.preventDefault();
    
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top - 32
        }, 800);
    });

});